module.exports = __webpack_public_path__ + "uz.b43ab446c6f2ed80fffe.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/uz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/uz.svg
// module chunks = styles